import { useArbeitsbereiche } from '@/domain/mitarbeiter/features/anlageassistent/hooks/useArbeitsbereiche/useArbeitsbereiche';
import { useStandortContext } from '@/features/standortContext/StandortContext';
import {
  Combobox,
  ComboboxContent,
  ComboboxItem,
  ComboboxList,
  ComboboxOption,
  ComboboxSearch,
  ComboboxTrigger,
} from '@e2n/ui/v2';
import { useTranslation } from 'react-i18next';

export function ArbeitsbereichMultiSelect({
  values,
  hideArbeitsbereiche,
  handleChange,
}: {
  values: string[];
  hideArbeitsbereiche?: string[];
  handleChange: (value: string[]) => void;
}) {
  const { t } = useTranslation();
  const { currentStandort } = useStandortContext();
  const { arbeitsbereiche } = useArbeitsbereiche(currentStandort.id);

  const options: ComboboxOption[] = arbeitsbereiche
    .filter((ab) => !hideArbeitsbereiche?.includes(ab.id))
    .map((option) => {
      return {
        value: option.id,
        label: option.name,
        color: option.getBorderColor(),
      };
    });
  return (
    <Combobox
      multiple
      options={options}
      value={values}
      onValueChange={handleChange}>
      <ComboboxTrigger placeholder={t('combobox.placeholder')} />
      <ComboboxContent>
        <ComboboxSearch />
        <ComboboxList>
          {options.map((o) => (
            <ComboboxItem key={o.value} option={o} />
          ))}
        </ComboboxList>
      </ComboboxContent>
    </Combobox>
  );
}
